export const ONBOARDING_V2_COMPLETE_STEP = 11;

export const ONBOARDING_V2_STORAGE_KEYS = {
  step: "onboarding_v2_step",
  form: "onboarding_v2_form",
  initCompleted: "onboarding_v2_init_completed",
  agentId: "onboarding_v2_agent_id",
  userId: "onboarding_v2_user_id",
} as const;

function readStoredOnboardingValue(key: string): unknown {
  if (typeof window === "undefined") {
    return null;
  }

  const rawValue = window.localStorage.getItem(key);

  if (rawValue === null) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch {
    return rawValue;
  }
}

export function getOnboardingV2StoredStep(): number | null {
  const storedStep = readStoredOnboardingValue(ONBOARDING_V2_STORAGE_KEYS.step);

  if (storedStep === null || storedStep === "") {
    return null;
  }

  const currentStep = Number(storedStep);

  if (!Number.isFinite(currentStep)) {
    return null;
  }

  return currentStep;
}

export function isOnboardingV2StoredUserMatching(userId?: string): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  const storedUserId = readStoredOnboardingValue(
    ONBOARDING_V2_STORAGE_KEYS.userId
  );

  if (
    userId &&
    typeof storedUserId === "string" &&
    storedUserId &&
    userId !== storedUserId
  ) {
    return false;
  }

  return true;
}

export function isOnboardingV2InitCompleted(): boolean {
  return (
    readStoredOnboardingValue(ONBOARDING_V2_STORAGE_KEYS.initCompleted) === true
  );
}

export function isOnboardingV2InProgress(userId?: string): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  if (!isOnboardingV2StoredUserMatching(userId)) {
    return false;
  }

  if (!isOnboardingV2InitCompleted()) {
    return false;
  }

  const currentStep = getOnboardingV2StoredStep();

  if (currentStep === null) {
    return false;
  }

  return currentStep > 0 && currentStep < ONBOARDING_V2_COMPLETE_STEP;
}

export function shouldMaskUserSectorIdInOnboardingV2(userId?: string): boolean {
  return isOnboardingV2InProgress(userId);
}

export function isOnboardingV2FinalStepPersisted(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  if (!isOnboardingV2InitCompleted()) {
    return false;
  }

  return getOnboardingV2StoredStep() === ONBOARDING_V2_COMPLETE_STEP;
}

export function clearOnboardingV2WizardStorage(): void {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(ONBOARDING_V2_STORAGE_KEYS.step);
  window.localStorage.removeItem(ONBOARDING_V2_STORAGE_KEYS.form);
  window.localStorage.removeItem(ONBOARDING_V2_STORAGE_KEYS.initCompleted);
  window.localStorage.removeItem(ONBOARDING_V2_STORAGE_KEYS.agentId);
  window.localStorage.removeItem(ONBOARDING_V2_STORAGE_KEYS.userId);
}
